import React from 'react'
import styled from 'styled-components'
import WorldMap from '../images/map.png'

const Container = styled.div`
    background-image: url(${WorldMap});
    background-size: auto 100%;
    background-repeat: no-repeat;
    background-position: center center;
`
const ColumnContainer = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
`
// Display a title prop and a container consisting of 1-3 TriColumn components.
const TriColumnContainer = ({ children, title }) => {
    return (
        <Container>
            <h5>{title}</h5>
            <ColumnContainer>{children}</ColumnContainer>
        </Container>
    )
}

export default TriColumnContainer
